import CourseEditPage, { CourseEditPageProps } from './CourseEditPage';

export type { CourseEditPageProps };
export default CourseEditPage;
